import { BONUS_TYPE } from '../../constants';
import { useAllTypesBonuses, useIsBsWagerBonusActive } from '../../store';
import { FreeSpinBonusCard } from '../FreeSpinBonusCard';
import { FundsBonusCard } from '../FundsBonusCard';
import { RiskFreeBonusCard } from '../RiskFreeBonusCard';

const componentsMapByBonusType = {
  [BONUS_TYPE.BS_PWB]: FundsBonusCard,
  [BONUS_TYPE.BS_PWS]: FundsBonusCard,
  [BONUS_TYPE.BS_FS]: FundsBonusCard,
  [BONUS_TYPE.CRM_FUNDS]: FundsBonusCard,
  [BONUS_TYPE.CRM_RISK_FREE]: RiskFreeBonusCard,
  [BONUS_TYPE.CRM_FREE_SPINS]: FreeSpinBonusCard
};

export const BonusCardByType = ({ bonusId, onAccept, onWagerAccept }) => {
  const isBsWagerActive = useIsBsWagerBonusActive();
  const allTypesBonusesData = useAllTypesBonuses();

  const { fullBonusType } = allTypesBonusesData[bonusId] || {};

  const CardComponent = componentsMapByBonusType[fullBonusType];

  return (
    <CardComponent
      bonusId={bonusId}
      onAccept={onAccept}
      onWagerAccept={onWagerAccept}
      isThereActiveBonus={isBsWagerActive}
    />
  );
};
